// extracted by mini-css-extract-plugin
module.exports = {"headerImage":"Recipe_headerImage__3EHlc","headerInfo":"Recipe_headerInfo__1YiA4"};